import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'campaign-form/list',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./FormList').default
      callback(null, component)
    }, 'FormList')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/FormList/index.js